/**
 * remove focus funtion for button, chip and other clickable elements
 * while RMWC buttons maintain a highlighted state after being clicked, MUI buttons revert to their original color.
 */
export const removeFocus = (
  ele: React.MutableRefObject<HTMLElement | null>,
  onClick:
    | React.MouseEventHandler<HTMLDivElement | HTMLButtonElement>
    | undefined,
  event: React.MouseEvent<HTMLDivElement | HTMLButtonElement>,
) => {
  onClick?.(event);
  setTimeout(() => {
    ele.current?.children[0].classList.remove(
      'mdc-ripple-upgraded--background-focused',
    );
    ele.current?.children[0].classList.remove(
      'mdc-ripple-upgraded--foreground-activation',
    );
  }, 300);
};
